import { useSearchParams } from "react-router-dom";
import { getCompanyData } from "../../utils";
import { Alert } from "@almafintech/react-components/Alert";
import Container from "../Container/Container";
import Layout from "../Layout/Layout";
import successIcon from "../../assets/images/icons/ui/ui-icon-success.svg";
import torosCapitalLogo from "../../assets/images/logos/toros-capital.png";
import winaLogo from "../../assets/images/logos/wina.svg";
import landTokenLogo from "../../assets/images/logos/landtoken.svg";
import mabraLogo from "../../assets/images/logos/Mabra.svg";
import styles from "./SuccessPage.module.scss";
import RedirectionModal from "./ui/RedirectionModal/RedirectionModal";
import { useAppSelector } from "../../app/hooks";
import { texts } from "./i18n";

const SuccessPage = () => {
  const {
    successContainer,
    body,
    logosContainer,
    torosLogo,
    companyLogo,
    landToken,
    mabra,
    link,
  } = styles;

  const {
    onboardingData: { language: onboardingLanguage },
    activeTemplate: { onboardingType },
  } = useAppSelector((state) => state);

  const [searchParams] = useSearchParams();
  const isLandToken = searchParams.get("landToken");
  const isMabra = searchParams.get("mabra");
  const isToros = searchParams.get("toros");
  const isWina = searchParams.get("wina");
  const signatories = searchParams.get("signatories");
  const redirectedTo = searchParams.get("redirectedTo");
  const language =
    (searchParams.get("language") as "es" | "en") ?? onboardingLanguage ?? "es";

  const isRedirectModalOpen = !!searchParams.get("redirecting");

  const { logo, logoClassname, companyName } = getCompanyData();

  return (
    <Layout
      hideLogo
      hideSupportButton
      hideStepper={onboardingType === "INTERACTIVE_BROKERS"}
    >
      <RedirectionModal language={language} isOpen={isRedirectModalOpen} />

      <Container className={successContainer}>
        <div className={logosContainer}>
          {isLandToken && (
            <img
              className={landToken}
              src={landTokenLogo}
              alt="Land Token logo"
              width={160}
            />
          )}
          {isMabra && (
            <img
              className={mabra}
              src={mabraLogo}
              alt="Mabra logo"
              width={160}
            />
          )}
          {isToros && (
            <img
              className={torosLogo}
              src={torosCapitalLogo}
              alt="Toros Capital logo"
              width={160}
            />
          )}

          {isWina && (
            <img
              className={companyLogo}
              src={winaLogo}
              alt="Wina logo"
              width={160}
            />
          )}

          <img
            className={`${companyLogo} ${
              logoClassname ? styles[logoClassname] : ""
            }`}
            src={logo}
            alt={`${companyName} logo`}
            width={160}
          />
        </div>

        <div className={body}>
          <img src={successIcon} alt="success" />

          <h1>{texts[language].success.title}</h1>

          {companyName !== "ALLARIA_ASSET_MANAGEMENT" && (
            <p>
              {signatories
                ? "Procesaremos tu solicitud y enviaremos un mail a cada firmante con las instrucciones para su registro."
                : texts[language].success.subtitle}
            </p>
          )}

          {signatories && (
            <Alert variant="INFO">
              Cuando los firmantes se registren, todos recibirán las
              instrucciones para acceder a la cuenta.
            </Alert>
          )}

          {!!redirectedTo && (
            <p>
              <a className={link} href={`${decodeURIComponent(redirectedTo)}`}>
                {texts[language].redundantRedirectLink}
              </a>
            </p>
          )}
        </div>
      </Container>
    </Layout>
  );
};

export default SuccessPage;
